import { StructureType } from './StructureType';

export const StructureTypeOptions = [
    {
        id: StructureType.DetachedHouse,
        name: 'Detached House',
        shortName: 'House',
    },
    {
        id: StructureType.Townhouse,
        name: 'Townhouse',
        shortName: 'Townhouse',
    },
    {
        id: StructureType.Duplex,
        name: 'Duplex',
        shortName: 'Duplex',
    },
    {
        id: StructureType.Triplex,
        name: 'Triplex',
        shortName: 'Triplex',
    },
    {
        id: StructureType.Quadplex,
        name: 'Quadplex',
        shortName: 'Quadplex',
    },
    {
        id: StructureType.FivePlus,
        name: '5+ Unit',
        shortName: '5+ Unit',
    },
    {
        id: StructureType.CondoInStructure,
        name: 'Single Condo Unit in Larger Structure',
        shortName: 'Sngl Condo',
    },
    {
        id: StructureType.Various,
        name: 'Various',
        shortName: 'Various',
    },
];
